import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEO({ 
  title = 'TradePro - Professional Trading Solutions & Investment Services',
  description = 'Expert trading solutions, investment strategies, and financial consulting. Join thousands of successful traders with our proven trading systems and professional guidance.',
  keywords = 'trading, investment, forex, stocks, crypto, portfolio management, financial consulting, trading education',
  image = 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop',
  url = window.location.href
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="TradePro" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}

export default SEO;